<template>
  <DefaultLayout :disableFacilitatorTools="true">
    <div>
      <div>
        <br />
        <div class="text-center">
          <h4>{{ $t("gamestitle") }}</h4>
          <base-button class="myButton" type="primary" style="white-space: normal;margin: 2px" @click="back()">{{
            $t("back_to_games_list")
          }}</base-button>
        </div>
      </div>
      <br />

      <div>
        <vue-good-table
          mode="remote"
          :rows="rows"
          :columns="columns"
          :totalRows="totalRecords"
          styleClass="vgt-table striped"
          :sort-options="{
            enabled: false,
          }"
          :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 100,
            nextLabel: $t('next'),
            prevLabel: $t('previous'),
            dropdownAllowAll: false,
            perPageDropdown: [100, 500, 1000],
            rowsPerPageLabel: $t('rowsperpage'),
            ofLabel: 'of',
            pageLabel: 'page', // for 'pages' mode
            allLabel: $t('all'),
          }"
          @on-page-change="onPageChange"
          @on-per-page-change="onPerPageChange"          
        >
          <div slot="emptystate"></div>

          <template slot="table-column" slot-scope="props">
            <span v-if="props.column.label != 'after'">
              {{ $t(props.column.label) }}</span
            >
          </template>

          <template slot="table-row" slot-scope="props">
            <small>
              <span v-if="props.column.field == 'opened'">
                {{ getOpenedString(props.row.opened) }}
              </span>
              <span v-if="props.column.field == 'invoiced'">
                  <input
                    type="checkbox"
                    v-on:change="changeInvoiced(props.row)"
                    v-model="props.row.invoiced"
                  />                
              </span>           
              <span v-else>{{ props.row[props.column.field] }}</span>
            </small>
          </template>
        </vue-good-table>
        <br />
      </div>
    </div>
  </DefaultLayout>
</template>

<script>
import { VueGoodTable } from "vue-good-table";
import "vue-good-table/dist/vue-good-table.css";
import {
  getGamesHistoryPaged,
  updateGameInvoicedPartner,
} from "@/services/APIService";
import DefaultLayout from '@/layouts/DefaultLayout.vue';

const ExcelJS = require("exceljs");

export default {
  data() {
    return {
      columns: [
        {
          label: "name",
          field: "name",
        },
        {
          label: "company_name",
          field: "company_name",
          hidden: false,
        },
        {
          label: "additional_information",
          field: "additional_information",
          hidden: false,
          sortable: false,
        },
        {
          label: "username",
          field: "username",
          hidden: false,
        },
        {
          label: "invoiced",
          field: "invoiced",
          hidden: false,
        },
        {
          label: "demo",
          field: "demo",
          hidden: false,
        },
        {
          label: "demo_reason",
          field: "demo_reason",
          hidden: false,
        },
        {
          label: "opened",
          field: "opened",
        },
        {
          label: "reporting_open",
          field: "reporting_open",
        },
      ],
      rows: [],
      page: 1,
      perPage: 100,
      totalRecords: 0,
    };
  },
  components: {
    VueGoodTable,
    DefaultLayout,
  },
  mounted() {
   this.loadItems();
  },
  methods: {
    getOpenedString(openedTime) {
      if (!openedTime) {
        return "";
      } else {
        return openedTime.split("T")[0];
      }
    },
    async loadItems() {
      getGamesHistoryPaged(this.page, this.perPage).then((games) => {
        this.rows = games.results;
        this.totalRecords = games.count;
      });
    },
    changeInvoiced(row) {
      updateGameInvoicedPartner(row.id, row.invoiced);
    },
    //REST PAGINATION HANDLERS
    onPageChange(params) {
      this.page = params.currentPage;
      this.loadItems();
    },
    onPerPageChange(params) {
      this.perPage = params.currentPerPage;
      this.loadItems();
    },
    back() {
      this.$router.push("/admin/games/");
    },
  },
};
</script>

<i18n>
{
  "en": {
    "name": "Name",
    "gamestitle": "Simulations History",
    "next": "next",
    "previous": "previous",
    "rowsperpage": "rows per page",
    "company_name": "Company",
    "opened": "Opening time",
    "username": "Created by",
    "additional_information": "Additional information",
    "demo": "Demonstration simulation (non-billable)",
    "demo_reason": "Demo reason",
    "back_to_games_list": "Return to games list",
    "reporting_open": "Reporting opened",
    "invoiced": "Invoiced"
  },
  "sv": {
    "name": "Simuleringens namn",
    "gamestitle": "Simulering historia",
    "next": "nästa",
    "previous": "föregående",
    "rowsperpage": "rader på sidan",
    "company_name": "Företagsnamnet",
    "opened": "Simuleringen öppnad",
    "username": "Skapad av",
    "additional_information": "Identifiering",
    "demo": "Demosimulering (ej fakturerad)",
    "demo_reason": "I vilket syfte visas simuleringen",
    "back_to_games_list": "Återgå till spellistan",
    "reporting_open": "Rapportering öppnad",
    "invoiced": "Faktureras"
  },
  "fi": {
    "name": "Simulaation nimi",
    "gamestitle": "Simulaatiohistoria",
    "next": "seuraava",
    "previous": "edellinen",
    "rowsperpage": "rivejä sivulla",
    "company_name": "Yritys",
    "opened": "Simulaatio avattu",
    "username": "Luonut",
    "additional_information": "Yksilöintitieto",
    "demo": "Esittelysimulaatio (ei laskutettava)",
    "demo_reason": "Mihin tarkoitukseen simulaatiota esitellään",
    "back_to_games_list": "Palaa pelilistaukseen",
    "reporting_open": "Raportti avattu",
    "invoiced": "Laskutettu"
  },
  "de": {
    "name": "Name",
    "gamestitle": "Simulationsgeschichte",
    "next": "weiter",
    "previous": "zurück",
    "rowsperpage": "Zeilen pro Seite",
    "company_name": "Unternehmen",
    "opened": "Öffnungszeit",
    "username": "Erstellt von",
    "additional_information": "Zusätzliche Informationen",
    "demo": "Demonstrations-Simulation (nicht abrechenbar)",
    "demo_reason": "Informationen über die Demo an",
    "back_to_games_list": "Zurück zur Spieleliste",
    "reporting_open": "Berichterstattung geöffnet",
    "invoiced": "Invoiced"
  },
  "ko": {
    "name": "이름",
    "gamestitle": "시뮬레이션 이력",
    "next": "다음",
    "previous": "이전",
    "rowsperpage": "한 페이지당 표시 개수",
    "company_name": "회사명",
    "opened": "개설 날짜",
    "username": "개설자",
    "additional_information": "추가 정보",
    "demo": "프로모션 게임 (무료)",
    "demo_reason": "프로모션 게임 개설 사유를 입력하십시오.",
    "back_to_games_list": "게임 목록으로 돌아가기",
    "reporting_open": "결과보고서 확인 여부",
    "invoiced": "인보이스 발행"
  }
}
</i18n>
